import EstimatedIcon from "~icons/local/check-blue";
import NoBidIcon from "~icons/local/no-bid";

export default function PartStatusIcon({
  willBid,
  className = "",
}: {
  willBid: boolean | null;
  className?: string;
}) {
  return (
    willBid !== null && (
      <div className={className}>
        {willBid ? (
          <EstimatedIcon className="size-3" />
        ) : (
          <NoBidIcon className="size-3" />
        )}
      </div>
    )
  );
}
